import React from 'react';
import { useTimezone } from '../../hooks/useTimezone';
import './TimezoneDisplay.css';

export function TimezoneDisplay() {
  const { timezone } = useTimezone();
  
  return (
    <span className="timezone-display" title={timezone}>
      {timezone}
    </span>
  );
}
